module.exports = __webpack_public_path__ + "static/media/maestrosycoaches.e4561f18.svg";